import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, map } from 'rxjs';
import { onUntouched } from 'src/app/shared/loading-state/loadable';
import { getVehicleList } from 'src/app/shared/vehicle/store/vehicle.actions';
import { selectVehicles } from '../../shared/vehicle/store/vehicle.selectors';

export const hasConnectedVehicles = (options?: { fallback?: readonly any[] }): CanActivateFn => {
  return () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(selectVehicles).pipe(
      onUntouched(() => store.dispatch(getVehicleList())),
      first(vehicles => !vehicles.isLoading && !!vehicles.value),
      map(vehicles => {
        return !!vehicles.value && vehicles.value.length > 0
          ? true
          : options?.fallback
            ? router.createUrlTree(options.fallback)
            : false;
      })
    );
  };
};
